import React, { Fragment, useState } from "react";
import "./vmlist.css";
import { Link } from "react-router-dom";
const VmListContainer2 = (props) => {
  const [vmlistData, setVmListData] = useState([
    { id: 1, name: "VM Alpha", operational_status: "Running" },
    { id: 2, name: "VM Beta", operational_status: "Stopped" },
    { id: 3, name: "VM Gamma", operational_status: "Maintenance" },
  ]);

 const [view1, setView1] = useState(true);
  const [view2, setView2] = useState(false);
  const [view3, setView3] = useState(false);
  const [view4, setView4] = useState(false);
   const [view5, setView5] = useState(false);
  const handleView1 = () => {
    setView1(!view1);
  };

    const handleView4 = () => {
    setView4(!view4);
  };

  const handleView5=()=>{
     setView5(!view5);

  }
  const handleView3 = () => {
    setView3(!view3);
  };
 const handleView2 = () => {
    setView2(!view2);
  };
  return (
   <div style={{display:"flex",overflow:"scroll",height:"100vh"}}>

      
    <div style={{marginLeft:"5%"}}>
        <div
        style={{
          width: "50vw",
          "box-shadow": " 0 2px 14px 1px #504c4c",
          "margin-bottom": "14px",
        }}
      >
        <div style={{ "margin-bottom": "44px" }}>
          <table>
            <th>
              <div style={{ display: "flex" }}>
                <input
                    type="search"
                  placeholder="Search by VM ID / VM name"
                  value={props.searchValue}
                  onKeyPress={props.handleKeyPress}
                  onChange={props.handleSearchInputChange}
             
                />
              </div>
            </th>
            <th>
              <Link to={"/home/configuration/vmcreation/newvmcreation"}
                style={{
                  "font-size": "14px",
                  padding: "14px",
                  color: "white",
                  "background-color": "green",
                  border: "none",
                  "border-radius": "10px",
                  width: "100%",
                }}
               
              >
                CREATE NEW VM
              </Link>
            </th>
          </table>
        </div>

        <hr />


          <div
            id="scrollableDiv"
            style={{ height: "690px", overflow: "auto", width: "100%" }}
          >
          

            <Fragment>
              <table style={{ width: "100%" }}>
                <tr>
                  <th>VM ID</th>
                  <th>VM NAME</th>
                  <th>STATUS</th>
                </tr>
                {props.filteredVmList && props.filteredVmList.length > 0&&
                        props.filteredVmList.map((el) => (
                    <Fragment >
                      {el.id > 0 && (
                        <Fragment>
                          <tr
                            style={{ cursor: "pointer" }}
                            key={el.id}
                            value={el.id}
                            onClick={(e) => {
                             props&&props.handleGetVmDetails(e,el.id);
                            }}
                          >
                            <td>{el.id}</td>

                            <td style={{ width: "50%" }}>{el.name}</td>

                            <td>{el.operational_status}</td>
                          </tr>
                        </Fragment>
                      )}
                    </Fragment>
                  ))}
              </table>
            </Fragment>
          </div>
        
      </div>
  </div>

  {props&&props.vmDetails && (
        <div
          style={{
            background: "fffff",
            width: "50vw",
            "margin-left": "2%",

            height: "59.7rem;",
            border: "2px solid beige",
            "overflow-y": "scroll",
            "overflow-x": "hidden",
            height: "880px",
            marginBottom: "14px",
            "box-shadow": " 0 2px 14px 1px #504c4c",
            "margin-right": "5%",

            /*  "box-shadow": "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)"
             */
          }}
        >
          <div
            style={{
              display: "flex",
              "justify-content": "space-between",
              "align-items": "center",
              padding: "10px",
            }}
          >
            <div style={{ display: "flex" }}>
              <div style={{ display: "flex",justifyItems:"center","align-items": "center" }}>
                <div>
                  <h3>STATUS:</h3>
                </div>
                <div>
                  <h3 style={{fontSize:"20px"}}>{props&&props.vmDetails.operational_status}</h3>
                </div>
              </div>
            </div>
            <div style={{display:"flex",marginRight:"5%"}}>
            {!(props&&props.vmDetails.operational_status === "Inactive") && (
            <></>
            )}

        
            </div>
          </div>

          <hr />

          <div style={{ padding: "1%" }}>
            <div style={{ width: "100%", display: "flex" }}>
              {}
              {props&&props.vmDetails.address.image_path ? (
                <img
                  style={{ width: "20%", height: "130px", padding: "1%" }}
                  src={"https://s3.ap-south-1.amazonaws.com/daalchini/dcprod/" + `${props&&props.vmDetails.address.image_path}`}
                />
              ) : (
                <img
                  style={{ width: "20%", height: "130px", padding: "1%" }}
                  src={"NoImg"}
                />
              )}

              <div style={{ padding: "1%", width: "100%" }}>
                <div style={{ display: "flex", padding: "1%" }}>
                  <h3 style={{ color: "brown", "font-size": "16px" }}>
                    VM NAME:&nbsp;
                  </h3>
                  {props&&props.vmDetails.name && (
                    <h3
                      style={{
                        marginTop: "0px",
                        "font-size": "16px",
                        "margin-left": "2px",
                      }}
                    >
                      {props&&props.vmDetails.name}
                    </h3>
                  )}
                </div>
             <div>
                <div style={{ display: "flex", padding: "1%" }}>
                  <div /* style={{width:"100%"}} */>
                    <h3 style={{ color: "brown", "font-size": "16px" }}>
                      RCOM ID:&nbsp;
                    </h3>
                  </div>
                  <div /* style={{width:"100%"}} */>
                    {props&&props.vmDetails.keys.com_id && (
                      <h3 style={{ marginTop: "0px", "font-size": "16px" }}>
                        {props&&props.vmDetails.keys.com_id}
                      </h3>
                    )}
                  </div>

                  <h3
                    style={{
                      color: "brown",
                      "margin-top": "0rem",
                      "margin-left": "2%",
                      "font-size": "16px",
                    }}
                  >
                    DEVICE ID:&nbsp;
                  </h3>
                  {props&&props.vmDetails.keys.device_id && (
                    <h3 style={{ marginTop: "0px", "font-size": "16px" }}>
                      {props&&props.vmDetails.keys.device_id}
                    </h3>
                  )}
                </div>

                <div style={{ display: "flex", padding: "1%" }}>
                  <h3 style={{ color: "brown", "font-size": "16px" }}>
                    BOARD ID:&nbsp;
                  </h3>
                  {props&&props.vmDetails.keys.board_id && (
                    <h3 style={{ marginTop: "0px", "font-size": "16px" }}>
                      {props&&props.vmDetails.keys.board_id}
                    </h3>
                  )}

                  <h3
                    style={{
                      color: "brown",
                      "margin-top": "0rem",
                      "font-size": "16px",
                      "margin-left": "2%",
                    }}
                  >
                    BLU ID:&nbsp;
                  </h3>
                  {props&&props.vmDetails.keys.bluetooth_id&& (
                    <h3 style={{ marginTop: "0px", "font-size": "16px" }}>
                      {props&&props.vmDetails.keys.bluetooth_id}
                    </h3>
                  )}
                </div>

                <div>
            <div style={{display:"flex"}}>
            <h3 style={{ color: "brown", "font-size": "16px" }}>

                    Serial Number:&nbsp;
                  </h3>
                  {props&&props.vmDetails.keys.board_id && (
                    <h3 style={{ marginTop: "0px", "font-size": "16px" }}>
                      {props&&props.vmDetails.keys.serial_number}
                    </h3>
                  )}

                  </div>
                  </div>
              </div>
            
            </div>
            </div>
       

          </div>

          <hr />
          {view1 && (
            <div>
              {" "}
              <div
                style={{ display: "flex", width: "99%", "margin-left": "2%" }}
              >
                <h3 style={{ color: "brown", "font-size": "16px" }}>
                  STREET:&nbsp;
                </h3>
                {props&&props.vmDetails.address.street && (
                  <h3
                    style={{
                      marginTop: "0px",
                      "font-size": "16px",
                      "margin-left": "2px",
                    }}
                  >
                    {props&&props.vmDetails.address.street}{" "}
                  </h3>
                )}
              </div>
              <div
                style={{ display: "flex", width: "99%", "margin-left": "2%" }}
              >
                <h3 style={{ color: "brown", "font-size": "16px" }}>
                  CITY:&nbsp;
                </h3>
                {props&&props.vmDetails.address.city && (
                  <h3
                    style={{
                      marginTop: "0px",
                      "font-size": "16px",
                      "margin-left": "2px",
                    }}
                  >
                    {" "}
                    {props&&props.vmDetails.address.city}{" "}
                  </h3>
                )}
              </div>
              <div
                style={{ display: "flex", width: "99%", "margin-left": "2%" }}
              >
                <h3 style={{ color: "brown", "font-size": "16px" }}>
                  STATE:&nbsp;
                </h3>
                {props&&props.vmDetails.address.state && (
                  <h3
                    style={{
                      marginTop: "0px",
                      "font-size": "16px",
                      "margin-left": "2px",
                    }}
                  >
                    {props&&props.vmDetails.address.state}
                  </h3>
                )}
              </div>
              <div
                style={{ display: "flex", width: "99%", "margin-left": "2%" }}
              >
                <h3 style={{ color: "brown", "font-size": "16px" }}>
                  LATITUDE:&nbsp;
                </h3>
                {props&&props.vmDetails.address.latitude && (
                  <h3
                    style={{
                      marginTop: "0px",
                      "font-size": "16px",
                      "margin-left": "2px",
                    }}
                  >
                    {props&&props.vmDetails.address.latitude}
                  </h3>
                )}
              </div>
              <div
                style={{ display: "flex", width: "99%", "margin-left": "2%" }}
              >
                <h3 style={{ color: "brown", "font-size": "16px" }}>
                  LONGITUDE:&nbsp;
                </h3>
                {props&&props.vmDetails.address.longitude && (
                  <h3
                    style={{
                      marginTop: "0px",
                      "font-size": "16px",
                      "margin-left": "2px",
                    }}
                  >
                    {props&&props.vmDetails.address.longitude}
                  </h3>
                )}
              </div>
              <div
                style={{ display: "flex", width: "99%", "margin-left": "2%" }}
              >
                <h3 style={{ color: "brown", "font-size": "16px" }}>
                  HARDWARE TYPE:&nbsp;
                </h3>
                {props&&props.vmDetails.hardware_type && (
                  <h3
                    style={{
                      marginTop: "0px",
                      "font-size": "16px",
                      "margin-left": "2px",
                    }}
                  >
                    {props&&props.vmDetails.hardware_type}
                  </h3>
                )}
              </div>
              <div
                style={{ display: "flex", width: "99%", "margin-left": "2%" }}
              >
                <h3 style={{ color: "brown", "font-size": "16px" }}>
                  VM TYPE:&nbsp;
                </h3>
                {props&&props.vmDetails.machine_type && (
                  <h3
                    style={{
                      marginTop: "0px",
                      "font-size": "16px",
                      "margin-left": "2px",
                    }}
                  >
                    {props&&props.vmDetails.machine_type}
                  </h3>
                )}
              </div>
              <div
                style={{ display: "flex", width: "99%", "margin-left": "2%" }}
              >
                <h3 style={{ color: "brown", "font-size": "16px" }}>
                  HEALTH ALERT:&nbsp;
                </h3>
                <h3
                  style={{
                    marginTop: "0px",
                    "font-size": "16px",
                    "margin-left": "2px",
                  }}
                >
                  {props&&props.vmDetails.health_report_enabled ? (
                    <Fragment>True</Fragment>
                  ) : (
                    <Fragment>false</Fragment>
                  )}
                </h3>
              </div>
              <div style={{ display: "flex", width: "99%" }}>
                <h3
                  style={{
                    color: "brown",
                    "font-size": "16px",
                    "margin-left": "2%",
                  }}
                >
                  CONSUMER APP:&nbsp;
                </h3>
                <h3
                  style={{
                    marginTop: "0px",
                    "font-size": "16px",
                    "margin-left": "2px",
                  }}
                >
                  {props&&props.vmDetails.consumer_app_enabled ? (
                    <Fragment>True</Fragment>
                  ) : (
                    <Fragment>false</Fragment>
                  )}
                </h3>
              </div>
              <div style={{ display: "flex" }}>
                <h3
                  style={{
                    color: "brown",
                    "font-size": "16px",
                    "margin-left": "2%",
                  }}
                >
                  {" "}
                  MACHINE TYPE ID: &nbsp;
                </h3>
                {props&&props.vmDetails.machine_type_id && (
                  <h3
                    style={{
                      marginTop: "0px",
                      "font-size": "16px",
                      "margin-left": "2px",
                    }}
                  >
                    {props&&props.vmDetails.warehouse.id}
                  </h3>
                )}
              </div>
                <div style={{ display: "flex" }}>
                <h3
                  style={{
                    color: "brown",
                    "font-size": "16px",
                    "margin-left": "2%",
                  }}
                >
                  {" "}
                 CONSUMER APP: &nbsp;
                </h3>
                {props&&props.vmDetails.consumer_app_enabled && (
                  <h3
                    style={{
                      marginTop: "0px",
                      "font-size": "16px",
                      "margin-left": "2px",
                    }}
                  >
                    {props&&props.vmDetails.consumer_app_enabled}
                  </h3>
                )}
              </div>
                <div style={{ display: "flex" }}>
                <h3
                  style={{
                    color: "brown",
                    "font-size": "16px",
                    "margin-left": "2%",
                  }}
                >
                  {" "}
                 CART LIMIT: &nbsp;
                </h3>
                {props&&props.vmDetails.cart_limit && (
                  <h3
                    style={{
                      marginTop: "0px",
                      "font-size": "16px",
                      "margin-left": "2px",
                    }}
                  >
                    {props&&props.vmDetails.cart_limit}
                  </h3>
                )}
              </div>

                   <div style={{ display: "flex" }}>
                <h3
                  style={{
                    color: "brown",
                    "font-size": "16px",
                    "margin-left": "2%",
                  }}
                >
                  {" "}
                 INTERNET PROVIDER: &nbsp;
                </h3>
                {props&&props.vmDetails.internet_provider && (
                  <h3
                    style={{
                      marginTop: "0px",
                      "font-size": "16px",
                      "margin-left": "2px",
                    }}
                  >
                    {props&&props.vmDetails.internet_provider}
                  </h3>
                )}
              </div>
              

              
              <div style={{ display: "flex", width: "100%" }}>
                <h3
                  style={{
                    color: "brown",
                    "font-size": "16px",
                    "margin-left": "2%",
                  }}
                >
                  {" "}
                  WAREHOUSE NAME: &nbsp;
                </h3>
                {props&&props.vmDetails.warehouse && (
                  <h3
                    style={{
                      marginTop: "0px",
                      "font-size": "16px",
                      "margin-left": "2px",
                    }}
                  >
                    {props&&props.vmDetails.warehouse.name}
                  </h3>
                )}
              </div>
                 <div style={{ display: "flex", width: "100%" }}>
                <h3
                  style={{
                    color: "brown",
                    "font-size": "16px",
                    "margin-left": "2%",
                  }}
                >
                  {" "}
                  WAREHOUSE ID: &nbsp;
                </h3>
                {props&&props.vmDetails.warehouse && (
                  <h3
                    style={{
                      marginTop: "0px",
                      "font-size": "16px",
                      "margin-left": "2px",
                    }}
                  >
                    {props&&props.vmDetails.warehouse.id}
                  </h3>
                )}
              </div>
              {props&&props.vmDetails.corporate && (
                <Fragment>
      
                  <div style={{ display: "flex", width: "100%" }}>
                    <h3
                      style={{
                        color: "brown",
                        "font-size": "16px",
                        "margin-left": "2%",
                      }}
                    >
                      {" "}
                      CORPORATE NAME: &nbsp;
                    </h3>
                    {props&&props.vmDetails.corporate && (
                      <h3
                        style={{
                          marginTop: "0px",
                          "font-size": "16px",
                          "margin-left": "2px",
                        }}
                      >
                        {props&&props.vmDetails.corporate.name}
                      </h3>
                    )}
                  </div>
                              <div style={{ display: "flex" }}>
                    <h3
                      style={{
                        color: "brown",
                        "font-size": "16px",
                        "margin-left": "2%",
                      }}
                    >
                      {" "}
                      CORPORATE ID: &nbsp;
                    </h3>
                    {props&&props.vmDetails.corporate && (
                      <h3
                        style={{
                          marginTop: "0px",
                          "font-size": "16px",
                          "margin-left": "2px",
                        }}
                      >
                        {props&&props.vmDetails.corporate.id}
                      </h3>
                    )}
                  </div>
                </Fragment>
              )}
            </div>
          )}

          <div>
            <hr />
            <p
              onClick={handleView1}
              style={{
                "text-align": "center",
                color: "blue",
                cursor: "pointer",
              }}
            >
              {view1 ? <Fragment>HIDE</Fragment> : <Fragment>VIEW</Fragment>}
            </p>
          </div>

          <div>
            <div>
              <hr />
              <p
                style={{ display: "flex", "justify-content": " space-around" }}
              >
                COHORTS{" "}
                <p
                  onClick={handleView2}
                  style={{
                    "text-align": "center",
                    color: "blue",
                    cursor: "pointer",
                  }}
                >
                  {view2 ? (
                    <Fragment>HIDE</Fragment>
                  ) : (
                    <Fragment>VIEW</Fragment>
                  )}
                </p>
              </p>
            </div>
            <hr />

            {view2 && (
              <div>
                <table style={{ width: "100%" }}>
                  <tr>
                    <th>ID</th>
                    <th>NAME</th>
                  </tr>
                 
 {props&&props.vmDetails.cohorts &&
                     props&&props.vmDetails.cohorts.length &&
                     props&&props.vmDetails.cohorts.map((el) => (
                      <Fragment>
                        {el.id > 0 && (
                          <Fragment>
                            <tr
                              style={{ cursor: "pointer" }}
                              key={el.id}
                              value={el.id}
                            >
                              <td>{el.id}</td>

                              <td>{el.name}</td>
                            </tr>
                          </Fragment>
                        )}
                      </Fragment>
                    ))}
                </table>
              </div>
            )}


  

        

          </div>

        


          <div>
            <p style={{ display: "flex", "justify-content": " space-around" }}>
              SLOTS{" "}
              <p
                onClick={handleView3}
                style={{
                  "text-align": "center",
                  color: "blue",
                  cursor: "pointer",
                  marginLeft: "7%",
                }}
              >
                {view3 ? (
                  <Fragment style={{ cursor: "pointet" }}>HIDE</Fragment>
                ) : (
                  <Fragment>VIEW</Fragment>
                )}
              </p>
            </p>
            <hr />

            {view3 && (
              <div>
                <table style={{ width: "100%" }}>
                  <tr>
                    <th>ID</th>
                    <th>MV_ID</th>
                    <th>CAPACITY</th>
                  </tr>
                  { props&&props.vmDetails.slots &&
                    props&&props.vmDetails.slots.length &&
                    props&&props.vmDetails.slots.map((el) => (
                      <Fragment>
                        {el.slot_id > 0 && (
                          <Fragment>
                            <tr
                              style={{ cursor: "pointer" }}
                              key={el.id}
                              value={el.id}
                              /*    onClick={(e) => {
                                OnClickVMSideDetailsPage(el.id);
                              }} */
                            >
                              <td>{el.slot_id}</td>

                              <td>{el.mv_id}</td>
                              <td>{el.capacity}</td>
                            </tr>
                          </Fragment>
                        )}
                      </Fragment>
                    ))}
                </table>
              </div>
            )}
          </div>

          <div>
            <p style={{ display: "flex", "justify-content": " space-around" }}>
              PAYMENTS
              <p
                onClick={handleView4}
                style={{
                  "text-align": "center",
                  color: "blue",
                  cursor: "pointer",
                }}
              >
                {view4 ? <Fragment>HIDE</Fragment> : <Fragment>VIEW</Fragment>}
              </p>
            </p>
            <hr />
            {view4 && (
              <div>
                <table style={{ width: "100%" }}>
                  <tr>
                    <th>PG-ID</th>
                    <th>NAME</th>
                  </tr>
                  { props&&props.vmDetails.payment_configs &&
                    props&&props.vmDetails.payment_configs.length &&
                    props&&props.vmDetails.payment_configs.map((el) => (
                      <Fragment>
                        {el.id > 0 && (
                          <Fragment>
                            <tr
                              style={{ cursor: "pointer" }}
                              key={el.id}
                              value={el.id}
                              /*   onClick={(e) => {
                                OnClickVMSideDetailsPage(el.id);
                              }} */
                            >
                              <td>{el.id}</td>

                              <td>{el.name}</td>
                            </tr>
                          </Fragment>
                        )}
                      </Fragment>
                    ))}
                </table>
              </div>
            )}
          </div>
        </div>
      )}

 
  </div>
  );
};

export default VmListContainer2;
